import React from 'react'
import './index.scss'

const CustomNotifocation: React.FC<any> = (props) => {
  return (
    <>
      <div className='notification'>
        <p>{props.message}</p>
      </div>
    </>
  )
}

export default CustomNotifocation
